import React from 'react'
import Banner from './Banner'
import Form from './Form'
import ContactDetails from './ContactDetails'

const Contactus = () => {
  return (
   <>
   <Banner/>
   <div className='flex justify-between md:px-[8%] '>
    <ContactDetails/>
   <Form/>
   </div>
   </>
  )
}

export default Contactus